export const initSmoothScroll = () => {
  const smoothScrolls = document.querySelectorAll(".smooth-scroll");
  if (!smoothScrolls) return;
  smoothScrolls.forEach((smoothScroll) => {
    smoothScroll.addEventListener("click", (e) => {
      e.preventDefault();
      const targetId = smoothScroll.hash;
      const targetElement = document.querySelector(targetId);
      const rectTop = targetElement.getBoundingClientRect().top;
      const offsetTop = window.pageYOffset;
      const buffer = 60;
      const top = rectTop + offsetTop - buffer;
      window.scrollTo({
        top,
        behavior: "smooth",
      });
    });
  });
};

export const initScrollHint = () => {
  const scrollables = document.querySelectorAll(".scrollable");

  scrollables.forEach((scrollable) => {
    const scrollHint = document.createElement("div");
    scrollHint.className = "scroll-hint scroll-hint--show";
    scrollHint.innerHTML = '<i class="fa-duotone fa-right"></i>';
    scrollable.appendChild(scrollHint);

    const showScrollHint = () => {
      if (scrollable.scrollWidth > scrollable.clientWidth) {
        scrollHint.classList.add("scroll-hint--show");
      } else {
        scrollHint.classList.remove("scroll-hint--show");
      }
    };
    showScrollHint();

    scrollable.addEventListener("scroll", () => {
      scrollHint.classList.remove("scroll-hint--show");
    });
  });
};
